import React from 'react'
import { Formik } from 'formik'
import { Col, Row, Toast, Form } from 'react-bootstrap'
import { StyledInput, StyledTitle, StyledSubtitle, StyledError,StyledInputMask, StyledCheck } from './styled'
import { Button } from './../../components'
import * as Yup from 'yup'
import { sendContact } from './../../core/api/mailer-provider'

const PartnerForm = (props) => {

    const [show, setShow] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    
    return (
        <>
            
            <Col xs={12} className='d-flex flex-column justify-content-center align-items-center mb-5 text-center'>
                <StyledTitle>
                    Deseja ser um parceiro?
                </StyledTitle>
                <StyledSubtitle>
                    Cadastre-se, seja um fornecedor de:
                </StyledSubtitle>
            </Col>
    
            <Formik
            initialValues={{
                companyName: '',
                name: '',
                address: '',
                city: '',
                cep: '',
                email: '',
                department: '',
                phone: '',
                serviceType: ''
            }}
            validationSchema={Yup.object({
                companyName: Yup.string().required('* Campo obrigatório'),
                name: Yup.string().required('* Campo obrigatório'),
                address: Yup.string().required('* Campo obrigatório'),
                city: Yup.string().required('* Campo obrigatório'),
                cep: Yup.string().required('* Campo obrigatório'),
                email: Yup.string().required('* Campo obrigatório'),
                department: Yup.string().required('* Campo obrigatório'),
                phone: Yup.string().required('* Campo obrigatório'),
            })}
            onSubmit={(values, helper) => {
                setLoading(true)
                sendContact({
                    subject: `Contato Parceria ${values.companyName}`,
                    // mailto: 'dgbarbosa96@gmail.com',
                    mailto: 'suprimentos.fr@fr-instalacoes.com.br',
                    body: `
                        <p style='font-weight: bold; font-size: 16px;'>${values.companyName}</p>
                        <p>Razão social: ${values.companyName}</p>
                        <p>Nome do representante: ${values.name}</p>
                        <p>Endereço: ${values.address}</p>
                        <p>Cidade: ${values.city}</p>
                        <p>Cep: ${values.cep}</p>
                        <p>E-mail: ${values.email}</p>
                        <p>Departamento: ${values.department}</p>
                        <p>Serviço: ${values.serviceType}</p>
                        <p>Celular: ${values.phone}</p>
                    `
                })
                .then(() => {
                    setLoading(false)
                    setShow(true)
                    setMessage('Email enviado com sucesso')
                    helper.resetForm()
                })
                .catch(() => {
                    setLoading(false)
                    setShow(true)
                    setMessage('Falha ao enviar o email')
                })
            }}
        >
            {
                ({
                    handleSubmit,
                    handleChange,
                    errors,
                    touched,
                    values,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Row className='mb-5'>
                            <Col className='d-flex justify-content-center'>
                                <Form className='d-flex flex-row'>
                                    <StyledCheck
                                        name='serviceType'
                                        className='mr-5'
                                        type='radio'
                                        id='serviceType'
                                        label='Material / Produto'
                                        value='Material / Produto'
                                        checked={values.serviceType == 'Material / Produto'}
                                        onChange={handleChange}
                                    />

                                    <StyledCheck
                                        name='serviceType'
                                        type='radio'
                                        id='serviceType'
                                        label='Serviço'
                                        value='Serviço'
                                        checked={values.serviceType == 'Serviço'}
                                        onChange={handleChange}
                                    />
                                </Form>
                            </Col>
                        </Row>
                        <Row>
                            <Col 
                                md={{
                                    span: 5,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='text'
                                    name='companyName'
                                    placeholder='Razão Social'
                                    onChange={handleChange}
                                    value={values.companyName}
                                    disabled={loading}
                                />
                                {errors.companyName && touched.companyName && <StyledError>{errors.companyName}</StyledError>}
                            </Col>
                            <Col
                                md={{
                                    span: 5
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='text'
                                    name='name'
                                    placeholder='Nome do representante'
                                    onChange={handleChange}
                                    disabled={loading}
                                    value={values.name}
                                />
                                {errors.name && touched.name && <StyledError>{errors.name}</StyledError>}

                            </Col>
                        </Row>

                        <Row>
                            <Col
                                md={{
                                    span: 5,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='text'
                                    name='address'
                                    placeholder='Endereço'
                                    onChange={handleChange}
                                    disabled={loading}
                                    value={values.address}
                                />
                                {errors.address && touched.address && <StyledError>{errors.address}</StyledError>}
                            </Col>
                            <Col
                                md={{
                                    span: 5
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='text'
                                    name='city'
                                    placeholder='Cidade'
                                    disabled={loading}
                                    onChange={handleChange}
                                    value={values.city}
                                />
                                {errors.city && touched.city && <StyledError>{errors.city}</StyledError>}
                            </Col>
                        </Row>

                        <Row> 
                            <Col
                                md={{
                                    span: 5,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInputMask
                                    name='cep'
                                    placeholder='CEP'
                                    disabled={loading}
                                    onChange={handleChange}
                                    value={values.cep}
                                    mask='99999-9999'
                                />
                                {errors.cep && touched.cep && <StyledError>{errors.cep}</StyledError>}
                            </Col>
                            <Col
                                md={{
                                    span: 5
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='email'
                                    name='email'
                                    disabled={loading}
                                    placeholder='E-mail'
                                    onChange={handleChange}
                                    value={values.email}
                                />
                                {errors.email && touched.email && <StyledError>{errors.email}</StyledError>}
                            </Col>
                        </Row>

                        <Row> 
                            <Col
                                md={{
                                    span: 5,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='text'
                                    name='department'
                                    disabled={loading}
                                    placeholder='Setor'
                                    onChange={handleChange}
                                    value={values.department}
                                />
                                {errors.department && touched.department && <StyledError>{errors.department}</StyledError>}
                            </Col>
                            <Col
                                md={{
                                    span: 5
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInputMask
                                    name='phone'
                                    placeholder='Celular'
                                    onChange={handleChange}
                                    disabled={loading}
                                    value={values.phone}
                                    mask='(99) 99999-9999'
                                />
                                {errors.phone && touched.phone && <StyledError>{errors.phone}</StyledError>}
                            </Col>
                        </Row>

                        <Row className='mt-4 mx-0 px-0'>
                            <Col
                                md={{
                                    span: 10,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex justify-content-end'
                            >
                                <Button disabled={loading} type='submit' label='Enviar'/>
                            </Col>
                        </Row>

                    </form>
                )
            }
        </Formik>
        <div style={{position: 'fixed', bottom: 0, zIndex: 999, left: '50%', transform: 'translateX(-50%)'}}>
            <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide>
            <Toast.Body>{message}</Toast.Body>
            </Toast>
        </div>
        </>
    )
}

export default PartnerForm